/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import I18n from '../Translate/I18n';

class ConfirmDialog extends React.Component {
    render() {
        const { title, content, agreeButtonName, disagreeButtonName, open, callBackAgree, callBackDisAgree, extraContent } = this.props;
        return (
            <div>
                <Dialog
                    open={open}
                    keepMounted
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">
                        <I18n trans={title} />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            <I18n trans={content} />
                            {extraContent}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={callBackDisAgree} color="primary">
                            <I18n trans={disagreeButtonName} />
                        </Button>
                        <Button onClick={callBackAgree} color="primary">
                            <I18n trans={agreeButtonName} />
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

ConfirmDialog.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    extraContent: PropTypes.string,
    agreeButtonName: PropTypes.string.isRequired,
    disagreeButtonName: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    callBackAgree: PropTypes.func.isRequired,
    callBackDisAgree: PropTypes.func.isRequired,
};

export default ConfirmDialog;
